"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[921],{

/***/ 41166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EH": function() { return /* binding */ useIsUserAddedToken; },
/* harmony export */   "U8": function() { return /* binding */ useCurrency; },
/* harmony export */   "ZN": function() { return /* binding */ useIsTokenActive; },
/* harmony export */   "dQ": function() { return /* binding */ useToken; },
/* harmony export */   "e_": function() { return /* binding */ useAllTokens; },
/* harmony export */   "l6": function() { return /* binding */ useUnsupportedTokens; },
/* harmony export */   "uq": function() { return /* binding */ useOfficialsAndUserAddedTokens; },
/* harmony export */   "zd": function() { return /* binding */ useWarningTokens; }
/* harmony export */ });
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16441);
/* harmony import */ var _ethersproject_strings__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86237);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1505);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42918);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97477);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70024);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _state_lists_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8074);
/* harmony import */ var _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(410);
/* harmony import */ var _state_user_hooks_useUserAddedTokens__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69482);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97119);
/* harmony import */ var _useContract__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80070);
/* harmony import */ var _useNativeCurrency__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19915);
/* eslint-disable no-param-reassign */ 












var mapWithoutUrls = function(tokenMap, chainId) {
    return Object.keys(tokenMap[chainId] || {}).reduce(function(newMap, address) {
        newMap[address] = tokenMap[chainId][address].token;
        return newMap;
    }, {});
};
/**
 * Returns all tokens that are from active urls and user added tokens
 */ function useAllTokens() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().chainId;
    var tokenMap = (0,jotai__WEBPACK_IMPORTED_MODULE_10__/* .useAtomValue */ .Dv)(_state_lists_hooks__WEBPACK_IMPORTED_MODULE_4__/* .combinedTokenMapFromActiveUrlsAtom */ .i);
    var userAddedTokens = (0,_state_user_hooks_useUserAddedTokens__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return userAddedTokens// reduce into all ALL_TOKENS filtered by the current chain
        .reduce(function(tokenMap_, token) {
            tokenMap_[token.address] = token;
            return tokenMap_;
        }, // must make a copy because reduce modifies the map, and we do not
        // want to make a copy in every iteration
        mapWithoutUrls(tokenMap, chainId));
    }, [
        userAddedTokens,
        tokenMap,
        chainId
    ]);
}
/**
 * Returns all tokens that are from officials token list and user added tokens
 */ function useOfficialsAndUserAddedTokens() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().chainId;
    var tokenMap = (0,jotai__WEBPACK_IMPORTED_MODULE_10__/* .useAtomValue */ .Dv)(_state_lists_hooks__WEBPACK_IMPORTED_MODULE_4__/* .combinedTokenMapFromOfficialsUrlsAtom */ .HW);
    var userAddedTokens = (0,_state_user_hooks_useUserAddedTokens__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return userAddedTokens// reduce into all ALL_TOKENS filtered by the current chain
        .reduce(function(tokenMap_, token) {
            tokenMap_[token.address] = token;
            return tokenMap_;
        }, // must make a copy because reduce modifies the map, and we do not
        // want to make a copy in every iteration
        mapWithoutUrls(tokenMap, chainId));
    }, [
        userAddedTokens,
        tokenMap,
        chainId
    ]);
}
function useUnsupportedTokens() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().chainId;
    var unsupportedTokensMap = (0,_state_lists_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useUnsupportedTokenList */ .Rx)();
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return mapWithoutUrls(unsupportedTokensMap, chainId);
    }, [
        unsupportedTokensMap,
        chainId
    ]);
}
function useWarningTokens() {
    var warningTokensMap = (0,_state_lists_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useWarningTokenList */ .c6)();
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().chainId;
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return mapWithoutUrls(warningTokensMap, chainId);
    }, [
        warningTokensMap,
        chainId
    ]);
}
function useIsTokenActive(token) {
    var activeTokens = useAllTokens();
    if (!activeTokens || !token) {
        return false;
    }
    return !!activeTokens[token.address];
}
// Check if currency is included in custom list from user storage
function useIsUserAddedToken(currency) {
    var userAddedTokens = (0,_state_user_hooks_useUserAddedTokens__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    if (!currency) {
        return false;
    }
    return !!userAddedTokens.find(function(token) {
        return currency === null || currency === void 0 ? void 0 : currency.equals(token);
    });
}
// parse a name or symbol from a token response
var BYTES32_REGEX = /^0x[a-fA-F0-9]{64}$/;
function parseStringOrBytes32(str, bytes32, defaultValue) {
    return str && str.length > 0 ? str : bytes32 && BYTES32_REGEX.test(bytes32) && (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_11__.arrayify)(bytes32)[31] === 0 ? (0,_ethersproject_strings__WEBPACK_IMPORTED_MODULE_12__/* .parseBytes32String */ .F)(bytes32) : defaultValue;
}
// undefined if invalid or does not exist
// null if loading
// otherwise returns the token
function useToken(tokenAddress) {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().chainId;
    var tokens = useAllTokens();
    var address = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .isAddress */ .UJ)(tokenAddress);
    var tokenContract = (0,_useContract__WEBPACK_IMPORTED_MODULE_8__/* .useTokenContract */ .Ib)(address || undefined, false);
    var tokenContractBytes32 = (0,_useContract__WEBPACK_IMPORTED_MODULE_8__/* .useBytes32TokenContract */ .gs)(address || undefined, false);
    var token = address ? tokens[address] : undefined;
    var tokenName = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSingleCallResult */ .Wk)(token ? undefined : tokenContract, "name", undefined, _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .NEVER_RELOAD */ .DB);
    var tokenNameBytes32 = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSingleCallResult */ .Wk)(token ? undefined : tokenContractBytes32, "name", undefined, _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .NEVER_RELOAD */ .DB);
    var symbol = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSingleCallResult */ .Wk)(token ? undefined : tokenContract, "symbol", undefined, _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .NEVER_RELOAD */ .DB);
    var symbolBytes32 = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSingleCallResult */ .Wk)(token ? undefined : tokenContractBytes32, "symbol", undefined, _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .NEVER_RELOAD */ .DB);
    var decimals = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSingleCallResult */ .Wk)(token ? undefined : tokenContract, "decimals", undefined, _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_5__/* .NEVER_RELOAD */ .DB);
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (token) return token;
        if (!chainId || !address) return undefined;
        if (decimals.loading || symbol.loading || tokenName.loading) return null;
        if (decimals.result) {
            var ref, ref1, ref2, ref3;
            return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU(chainId, address, decimals.result[0], parseStringOrBytes32((ref = symbol.result) === null || ref === void 0 ? void 0 : ref[0], (ref1 = symbolBytes32.result) === null || ref1 === void 0 ? void 0 : ref1[0], "UNKNOWN"), parseStringOrBytes32((ref2 = tokenName.result) === null || ref2 === void 0 ? void 0 : ref2[0], (ref3 = tokenNameBytes32.result) === null || ref3 === void 0 ? void 0 : ref3[0], "Unknown Token"));
        }
        return undefined;
    }, [
        address,
        chainId,
        decimals.loading,
        decimals.result,
        symbol.loading,
        symbol.result,
        symbolBytes32.result,
        token,
        tokenName.loading,
        tokenName.result,
        tokenNameBytes32.result, 
    ]);
}
function useCurrency(currencyId) {
    var ref;
    var native = (0,_useNativeCurrency__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var isNative = (currencyId === null || currencyId === void 0 ? void 0 : currencyId.toUpperCase()) === ((ref = native.symbol) === null || ref === void 0 ? void 0 : ref.toUpperCase()) || (currencyId === null || currencyId === void 0 ? void 0 : currencyId.toLowerCase()) === config_constants__WEBPACK_IMPORTED_MODULE_1__/* .GELATO_NATIVE */ .ag;
    var token = useToken(isNative ? undefined : currencyId);
    return isNative ? native : token;
}


/***/ }),

/***/ 921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ useUserSlippageTolerance; },
/* harmony export */   "$f": function() { return /* binding */ useZapModeManager; },
/* harmony export */   "A6": function() { return /* binding */ useUserTransactionTTL; },
/* harmony export */   "B3": function() { return /* binding */ useTrackedTokenPairs; },
/* harmony export */   "Ce": function() { return /* binding */ toV2LiquidityToken; },
/* harmony export */   "DG": function() { return /* binding */ useExpertModeManager; },
/* harmony export */   "Fh": function() { return /* binding */ useGasPrice; },
/* harmony export */   "LO": function() { return /* binding */ useIsExpertMode; },
/* harmony export */   "QG": function() { return /* binding */ useRemoveUserAddedToken; },
/* harmony export */   "RO": function() { return /* binding */ useUserSingleHopOnly; },
/* harmony export */   "TO": function() { return /* binding */ useAudioModeManager; },
/* harmony export */   "XD": function() { return /* binding */ useUserFarmStakedOnly; },
/* harmony export */   "YF": function() { return /* binding */ useSubgraphHealthIndicatorManager; },
/* harmony export */   "_E": function() { return /* binding */ useAddUserToken; },
/* harmony export */   "uB": function() { return /* binding */ usePairAdder; },
/* harmony export */   "vD": function() { return /* binding */ useExchangeChartManager; },
/* harmony export */   "wX": function() { return /* binding */ useUserExpertModeAcknowledgementShow; },
/* harmony export */   "y9": function() { return /* binding */ useUserFarmsViewMode; }
/* harmony export */ });
/* unused harmony exports usePhishingBannerManager, useExchangeChartViewManager, useUserPoolStakedOnly, useUserPoolsViewMode, useUserPredictionAcceptedRisk, useUserLimitOrderAcceptedWarning, useUserPredictionChartDisclaimerShow, useUserPredictionChainlinkChartDisclaimerShow, useUserUsernameVisibility, useWatchlistTokens, useWatchlistPools */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97582);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1505);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30693);
/* harmony import */ var lodash_flatMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94654);
/* harmony import */ var lodash_flatMap__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_flatMap__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _pancakeswap_farms_constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(37971);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56974);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97477);
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49770);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69077);
/* harmony import */ var hooks_Tokens__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41166);
/* harmony import */ var _pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29315);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8100);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(106);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9372);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96470);




















function useAudioModeManager() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var audioPlay = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.audioPlay;
    });
    var toggleSetAudioMode = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        if (audioPlay) {
            dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .muteAudio */ .B8)());
        } else {
            dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .unmuteAudio */ .u7)());
        }
    }, [
        audioPlay,
        dispatch
    ]);
    return [
        audioPlay,
        toggleSetAudioMode
    ];
}
function usePhishingBannerManager() {
    var dispatch = useAppDispatch();
    var hideTimestampPhishingWarningBanner = useSelector(function(state) {
        return state.user.hideTimestampPhishingWarningBanner;
    });
    var now = Date.now();
    var showPhishingWarningBanner = hideTimestampPhishingWarningBanner ? differenceInDays(now, hideTimestampPhishingWarningBanner) >= 1 : true;
    var hideBanner = useCallback(function() {
        dispatch(hidePhishingWarningBanner());
    }, [
        dispatch
    ]);
    return [
        showPhishingWarningBanner,
        hideBanner
    ];
}
// Get user preference for exchange price chart
// For mobile layout chart is hidden by default
function useExchangeChartManager(isMobile) {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var isChartDisplayed = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.isExchangeChartDisplayed;
    });
    var setUserChartPreference = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(isDisplayed) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .setIsExchangeChartDisplayed */ .hN)(isDisplayed));
    }, [
        dispatch
    ]);
    return [
        isMobile ? false : isChartDisplayed,
        setUserChartPreference
    ];
}
function useExchangeChartViewManager() {
    var dispatch = useAppDispatch();
    var chartViewMode = useSelector(function(state) {
        return state.user.userChartViewMode;
    });
    var setUserChartViewPreference = useCallback(function(view) {
        dispatch(setChartViewMode(view));
    }, [
        dispatch
    ]);
    return [
        chartViewMode,
        setUserChartViewPreference
    ];
}
function useZapModeManager() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var zapEnabled = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return !state.user.userZapDisabled;
    });
    var setZapEnable = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(enable) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .setZapDisabled */ .G8)(!enable));
    }, [
        dispatch
    ]);
    return [
        zapEnabled,
        setZapEnable
    ];
}
function useSubgraphHealthIndicatorManager() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var isSubgraphHealthIndicatorDisplayed = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.isSubgraphHealthIndicatorDisplayed;
    });
    var setSubgraphHealthIndicatorDisplayedPreference = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(newIsDisplayed) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .setSubgraphHealthIndicatorDisplayed */ .Hr)(newIsDisplayed));
    }, [
        dispatch
    ]);
    return [
        isSubgraphHealthIndicatorDisplayed,
        setSubgraphHealthIndicatorDisplayedPreference
    ];
}
function useIsExpertMode() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.userExpertMode;
    });
}
function useExpertModeManager() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var expertMode = useIsExpertMode();
    var toggleSetExpertMode = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .updateUserExpertMode */ .zv)({
            userExpertMode: !expertMode
        }));
    }, [
        expertMode,
        dispatch
    ]);
    return [
        expertMode,
        toggleSetExpertMode
    ];
}
function useUserSingleHopOnly() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var singleHopOnly = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.userSingleHopOnly;
    });
    var setSingleHopOnly = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(newSingleHopOnly) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .updateUserSingleHopOnly */ .fO)({
            userSingleHopOnly: newSingleHopOnly
        }));
    }, [
        dispatch
    ]);
    return [
        singleHopOnly,
        setSingleHopOnly
    ];
}
function useUserSlippageTolerance() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var userSlippageTolerance = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.userSlippageTolerance;
    });
    var setUserSlippageTolerance = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(slippage) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .updateUserSlippageTolerance */ .rQ)({
            userSlippageTolerance: slippage
        }));
    }, [
        dispatch
    ]);
    return [
        userSlippageTolerance,
        setUserSlippageTolerance
    ];
}
function useUserFarmStakedOnly(isActive) {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var userFarmStakedOnly = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.userFarmStakedOnly;
    });
    var setUserFarmStakedOnly = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(stakedOnly) {
        var farmStakedOnly = stakedOnly ? _actions__WEBPACK_IMPORTED_MODULE_12__/* .FarmStakedOnly.TRUE */ .GR.TRUE : _actions__WEBPACK_IMPORTED_MODULE_12__/* .FarmStakedOnly.FALSE */ .GR.FALSE;
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .updateUserFarmStakedOnly */ .Gs)({
            userFarmStakedOnly: farmStakedOnly
        }));
    }, [
        dispatch
    ]);
    return [
        userFarmStakedOnly === _actions__WEBPACK_IMPORTED_MODULE_12__/* .FarmStakedOnly.ON_FINISHED */ .GR.ON_FINISHED ? !isActive : userFarmStakedOnly === _actions__WEBPACK_IMPORTED_MODULE_12__/* .FarmStakedOnly.TRUE */ .GR.TRUE,
        setUserFarmStakedOnly, 
    ];
}
function useUserPoolStakedOnly() {
    var dispatch = useAppDispatch();
    var userPoolStakedOnly = useSelector(function(state) {
        return state.user.userPoolStakedOnly;
    });
    var setUserPoolStakedOnly = useCallback(function(stakedOnly) {
        dispatch(updateUserPoolStakedOnly({
            userPoolStakedOnly: stakedOnly
        }));
    }, [
        dispatch
    ]);
    return [
        userPoolStakedOnly,
        setUserPoolStakedOnly
    ];
}
function useUserPoolsViewMode() {
    var dispatch = useAppDispatch();
    var userPoolsViewMode = useSelector(function(state) {
        return state.user.userPoolsViewMode;
    });
    var setUserPoolsViewMode = useCallback(function(viewMode) {
        dispatch(updateUserPoolsViewMode({
            userPoolsViewMode: viewMode
        }));
    }, [
        dispatch
    ]);
    return [
        userPoolsViewMode,
        setUserPoolsViewMode
    ];
}
function useUserFarmsViewMode() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var userFarmsViewMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.userFarmsViewMode;
    });
    var setUserFarmsViewMode = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(viewMode) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .updateUserFarmsViewMode */ .gk)({
            userFarmsViewMode: viewMode
        }));
    }, [
        dispatch
    ]);
    return [
        userFarmsViewMode,
        setUserFarmsViewMode
    ];
}
function useUserPredictionAcceptedRisk() {
    var dispatch = useAppDispatch();
    var userPredictionAcceptedRisk = useSelector(function(state) {
        return state.user.userPredictionAcceptedRisk;
    });
    var setUserPredictionAcceptedRisk = useCallback(function(acceptedRisk) {
        dispatch(updateUserPredictionAcceptedRisk({
            userAcceptedRisk: acceptedRisk
        }));
    }, [
        dispatch
    ]);
    return [
        userPredictionAcceptedRisk,
        setUserPredictionAcceptedRisk
    ];
}
function useUserLimitOrderAcceptedWarning() {
    var dispatch = useAppDispatch();
    var userLimitOrderAcceptedWarning = useSelector(function(state) {
        return state.user.userLimitOrderAcceptedWarning;
    });
    var setUserLimitOrderAcceptedWarning = useCallback(function(acceptedRisk) {
        dispatch(updateUserLimitOrderAcceptedWarning({
            userAcceptedRisk: acceptedRisk
        }));
    }, [
        dispatch
    ]);
    return [
        userLimitOrderAcceptedWarning,
        setUserLimitOrderAcceptedWarning
    ];
}
function useUserPredictionChartDisclaimerShow() {
    var dispatch = useAppDispatch();
    var userPredictionChartDisclaimerShow = useSelector(function(state) {
        return state.user.userPredictionChartDisclaimerShow;
    });
    var setPredictionUserChartDisclaimerShow = useCallback(function(showDisclaimer) {
        dispatch(updateUserPredictionChartDisclaimerShow({
            userShowDisclaimer: showDisclaimer
        }));
    }, [
        dispatch
    ]);
    return [
        userPredictionChartDisclaimerShow,
        setPredictionUserChartDisclaimerShow
    ];
}
function useUserPredictionChainlinkChartDisclaimerShow() {
    var dispatch = useAppDispatch();
    var userPredictionChainlinkChartDisclaimerShow = useSelector(function(state) {
        return state.user.userPredictionChainlinkChartDisclaimerShow;
    });
    var setPredictionUserChainlinkChartDisclaimerShow = useCallback(function(showDisclaimer) {
        dispatch(updateUserPredictionChainlinkChartDisclaimerShow({
            userShowDisclaimer: showDisclaimer
        }));
    }, [
        dispatch
    ]);
    return [
        userPredictionChainlinkChartDisclaimerShow,
        setPredictionUserChainlinkChartDisclaimerShow
    ];
}
function useUserExpertModeAcknowledgementShow() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var userExpertModeAcknowledgementShow = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.userExpertModeAcknowledgementShow;
    });
    var setUserExpertModeAcknowledgementShow = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(showAcknowledgement) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .updateUserExpertModeAcknowledgementShow */ ._C)({
            userExpertModeAcknowledgementShow: showAcknowledgement
        }));
    }, [
        dispatch
    ]);
    return [
        userExpertModeAcknowledgementShow,
        setUserExpertModeAcknowledgementShow
    ];
}
function useUserUsernameVisibility() {
    var dispatch = useAppDispatch();
    var userUsernameVisibility = useSelector(function(state) {
        return state.user.userUsernameVisibility;
    });
    var setUserUsernameVisibility = useCallback(function(usernameVisibility) {
        dispatch(updateUserUsernameVisibility({
            userUsernameVisibility: usernameVisibility
        }));
    }, [
        dispatch
    ]);
    return [
        userUsernameVisibility,
        setUserUsernameVisibility
    ];
}
function useUserTransactionTTL() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    var userDeadline = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.userDeadline;
    });
    var setUserDeadline = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(deadline) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .updateUserDeadline */ .gw)({
            userDeadline: deadline
        }));
    }, [
        dispatch
    ]);
    return [
        userDeadline,
        setUserDeadline
    ];
}
function useAddUserToken() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(token) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .addSerializedToken */ .eg)({
            serializedToken: token.serialize
        }));
    }, [
        dispatch
    ]);
}
function useRemoveUserAddedToken() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(chainId, address) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .removeSerializedToken */ .zQ)({
            chainId: chainId,
            address: address
        }));
    }, [
        dispatch
    ]);
}
function useGasPrice(chainIdOverride) {
    var ref;
    var ref1 = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), chainId_ = ref1.chainId, chain = ref1.chain;
    var library = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_9__/* .useWeb3LibraryContext */ .Hp)();
    var chainId = chainIdOverride !== null && chainIdOverride !== void 0 ? chainIdOverride : chainId_;
    var ref2 = (0,swr__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(library && library.provider && chainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC && [
        "bscProviderGasPrice",
        library.provider
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        var gasPrice;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        library.getGasPrice()
                    ];
                case 1:
                    gasPrice = _state.sent();
                    return [
                        2,
                        gasPrice.toString()
                    ];
            }
        });
    }), {
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), tmp = ref2.data, bscProviderGasPrice = tmp === void 0 ? _types__WEBPACK_IMPORTED_MODULE_13__/* .GAS_PRICE_GWEI["default"] */ .j4["default"] : tmp;
    var data = (0,wagmi__WEBPACK_IMPORTED_MODULE_16__/* .useFeeData */ .LK)({
        chainId: chainId,
        enabled: chainId !== _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC && chainId !== _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET,
        watch: true
    }).data;
    if (chainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC) {
        return bscProviderGasPrice;
    }
    if (chainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET) {
        return _types__WEBPACK_IMPORTED_MODULE_13__/* .GAS_PRICE_GWEI.testnet */ .j4.testnet;
    }
    if (chain === null || chain === void 0 ? void 0 : chain.testnet) {
        var ref3;
        return data === null || data === void 0 ? void 0 : (ref3 = data.formatted) === null || ref3 === void 0 ? void 0 : ref3.maxPriorityFeePerGas;
    }
    return data === null || data === void 0 ? void 0 : (ref = data.formatted) === null || ref === void 0 ? void 0 : ref.gasPrice;
}
function serializePair(pair) {
    return {
        token0: pair.token0.serialize,
        token1: pair.token1.serialize
    };
}
function usePairAdder() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_11__/* .useAppDispatch */ .TL)();
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(pair) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_12__/* .addSerializedPair */ .f9)({
            serializedPair: serializePair(pair)
        }));
    }, [
        dispatch
    ]);
}
/**
 * Given two tokens return the liquidity token that represents its liquidity shares
 * @param tokenA one of the two tokens
 * @param tokenB the other token
 */ function toV2LiquidityToken(param) {
    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(param, 2), tokenA = _param[0], tokenB = _param[1];
    return new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU(tokenA.chainId, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Pair.getAddress */ .sO.getAddress(tokenA, tokenB), 18, "Cake-LP", "Pancake LPs");
}
/**
 * Returns all the pairs of tokens that are tracked by the user for the current chain ID.
 */ function useTrackedTokenPairs() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().chainId;
    var tokens = (0,hooks_Tokens__WEBPACK_IMPORTED_MODULE_8__/* .useOfficialsAndUserAddedTokens */ .uq)();
    var _chainId;
    // pinned pairs
    var pinnedPairs = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return chainId ? (_chainId = config_constants_exchange__WEBPACK_IMPORTED_MODULE_5__/* .PINNED_PAIRS */ .Q8[chainId]) !== null && _chainId !== void 0 ? _chainId : [] : [];
    }, [
        chainId
    ]);
    var ref = (0,swr_immutable__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(chainId && [
        "track-farms-pairs",
        chainId
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        var farms, fPairs;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_pancakeswap_farms_constants__WEBPACK_IMPORTED_MODULE_18__.getFarmConfig)(chainId)
                    ];
                case 1:
                    farms = _state.sent();
                    fPairs = farms.filter(function(farm) {
                        return farm.pid !== 0;
                    }).map(function(farm) {
                        return [
                            (0,_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .deserializeToken */ .iG)(farm.token),
                            (0,_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .deserializeToken */ .iG)(farm.quoteToken)
                        ];
                    });
                    return [
                        2,
                        fPairs
                    ];
            }
        });
    })), tmp = ref.data, farmPairs = tmp === void 0 ? [] : tmp;
    // pairs for every token against every base
    var generatedPairs = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return chainId ? lodash_flatMap__WEBPACK_IMPORTED_MODULE_2___default()(Object.keys(tokens), function(tokenAddress) {
            var token = tokens[tokenAddress];
            var // loop through all bases on the current chain
            _chainId;
            // for each token on the current chain,
            return ((_chainId = config_constants_exchange__WEBPACK_IMPORTED_MODULE_5__/* .BASES_TO_TRACK_LIQUIDITY_FOR */ .xu[chainId]) !== null && _chainId !== void 0 ? _chainId : [])// to construct pairs of the given token with each base
            .map(function(base) {
                if (base.address === token.address) {
                    return null;
                }
                return [
                    base,
                    token
                ];
            }).filter(function(p) {
                return p !== null;
            });
        }) : [];
    }, [
        tokens,
        chainId
    ]);
    // pairs saved by users
    var savedSerializedPairs = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(param) {
        var pairs = param.user.pairs;
        return pairs;
    });
    var userPairs = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (!chainId || !savedSerializedPairs) return [];
        var forChain = savedSerializedPairs[chainId];
        if (!forChain) return [];
        return Object.keys(forChain).map(function(pairId) {
            return [
                (0,_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .deserializeToken */ .iG)(forChain[pairId].token0),
                (0,_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .deserializeToken */ .iG)(forChain[pairId].token1)
            ];
        });
    }, [
        savedSerializedPairs,
        chainId
    ]);
    var combinedList = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return userPairs.concat(generatedPairs).concat(pinnedPairs).concat(farmPairs);
    }, [
        generatedPairs,
        pinnedPairs,
        userPairs,
        farmPairs
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        // dedupes pairs of tokens in the combined list
        var keyed = combinedList.reduce(function(memo, param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(param, 2), tokenA = _param[0], tokenB = _param[1];
            var sorted = tokenA.sortsBefore(tokenB);
            var key = sorted ? "".concat(tokenA.address, ":").concat(tokenB.address) : "".concat(tokenB.address, ":").concat(tokenA.address);
            if (memo[key]) return memo;
            memo[key] = sorted ? [
                tokenA,
                tokenB
            ] : [
                tokenB,
                tokenA
            ];
            return memo;
        }, {});
        return Object.keys(keyed).map(function(key) {
            return keyed[key];
        });
    }, [
        combinedList
    ]);
}
var useWatchlistTokens = function() {
    var dispatch = useAppDispatch();
    var ref;
    var savedTokens = (ref = useSelector(function(state) {
        return state.user.watchlistTokens;
    })) !== null && ref !== void 0 ? ref : [];
    var updatedSavedTokens = useCallback(function(address) {
        dispatch(addWatchlistToken({
            address: address
        }));
    }, [
        dispatch
    ]);
    return [
        savedTokens,
        updatedSavedTokens
    ];
};
var useWatchlistPools = function() {
    var dispatch = useAppDispatch();
    var ref;
    var savedPools = (ref = useSelector(function(state) {
        return state.user.watchlistPools;
    })) !== null && ref !== void 0 ? ref : [];
    var updateSavedPools = useCallback(function(address) {
        dispatch(addWatchlistPool({
            address: address
        }));
    }, [
        dispatch
    ]);
    return [
        savedPools,
        updateSavedPools
    ];
};


/***/ }),

/***/ 69482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUserAddedTokens; }
/* harmony export */ });
/* unused harmony export userAddedTokenSelector */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97477);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30693);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);





var selectUserTokens = function(param) {
    var tokens = param.user.tokens;
    return tokens;
};
var ref;
var userAddedTokenSelector = function(chainId) {
    return (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(selectUserTokens, function(serializedTokensMap) {
        return Object.values((ref = serializedTokensMap === null || serializedTokensMap === void 0 ? void 0 : serializedTokensMap[chainId]) !== null && ref !== void 0 ? ref : {}).map(_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_2__/* .deserializeToken */ .iG);
    });
};
function useUserAddedTokens() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().chainId;
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)((0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return userAddedTokenSelector(chainId);
    }, [
        chainId
    ]));
}


/***/ })

}]);